import { Button } from '@/components/ui/button';
import { 
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger 
} from '@/components/ui/dropdown-menu';
import { MoreVertical, Settings, Trash2 } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface OrganizationActionsProps {
  onManage: () => void;
  onDelete: () => void;
}

export function OrganizationActions({ 
  onManage, 
  onDelete
}: OrganizationActionsProps) {
  const { t, dir } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onManage}>
          <Settings className={`h-4 w-4 ${dir === 'rtl' ? 'ml-2' : 'mr-2'}`} />
          {t('dashboard.admin.organizations.actions.manage')}
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={onDelete}
          className="text-destructive focus:text-destructive"
        >
          <Trash2 className={`h-4 w-4 ${dir === 'rtl' ? 'ml-2' : 'mr-2'}`} />
          {t('dashboard.admin.organizations.actions.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}